var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{stroke:#000000;stroke-width:0.3237;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_385_",
    d: "M24.4,0H1.6C0.7,0,0,0.7,0,1.6v22.8C0,25.3,0.7,26,1.6,26h22.8c0.9,0,1.6-0.7,1.6-1.6V1.6 C26,0.7,25.3,0,24.4,0z M9.8,18.7v-3.2h6.5v3.2H9.8z M16.2,20.3v4.1H9.8v-4.1H16.2z M16.2,5.7v3.2H9.8V5.7H16.2z M16.2,10.6v3.2 H9.8v-3.2H16.2z M8.1,13.8H1.6v-3.2h6.5V13.8z M8.1,15.4v3.2H1.6v-3.2H8.1z M17.9,15.4h6.5v3.2h-6.5V15.4z M17.9,13.8v-3.2h6.5v3.2 H17.9z M17.9,8.9V5.7h6.5v3.2H17.9z M8.1,5.7v3.2H1.6V5.7H8.1z M1.6,20.3h6.5v4.1H1.6V20.3z M17.9,24.4v-4.1h6.5v4.1H17.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/Table.d51c7502a2cb67648a9bc661e6b985da.svg";
export { ForwardRef as ReactComponent };